import React, { useState, useEffect } from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Table,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';

const EditGroupPermissionDialog = ({ onClose, onSave, data }) => {
    const [groupPermissionsData, setGroupPermissionsData] = useState(data);
    const [editDevices, setEditDevices] = useState(data.every((element) => element.edit_device === 1));
    const [editPolicies, setEditPolicies] = useState(data.every((element) => element.edit_policy === 1));
    const [editRates, setEditRates] = useState(data.every((element) => element.edit_energy === 1));
    const [viewDevices, setViewDevices] = useState(data.every((element) => element.view_devices === 1));
    const [wakeDevices, setWakeDevices] = useState(data.every((element) => element.wake_devices === 1));
    const [runReports, setRunReports] = useState(data.every((element) => element.run_reports === 1));

    useEffect(() => {
        if (groupPermissionsData.every((item) => item.edit_device === 1 || item.edit_device === true)) {
            setEditDevices(true);
        } else {
            setEditDevices(false);
        }
        if (groupPermissionsData.every((item) => item.edit_policy === 1 || item.edit_policy === true)) {
            setEditPolicies(true);
        } else {
            setEditPolicies(false);
        }
        if (groupPermissionsData.every((item) => item.edit_energy === 1 || item.edit_energy === true)) {
            setEditRates(true);
        } else {
            setEditRates(false);
        }
        if (groupPermissionsData.every((item) => item.view_devices === 1 || item.view_devices === true)) {
            setViewDevices(true);
        } else {
            setViewDevices(false);
        }
        if (groupPermissionsData.every((item) => item.wake_devices === 1 || item.wake_devices === true)) {
            setWakeDevices(true);
        } else {
            setWakeDevices(false);
        }
        if (groupPermissionsData.every((item) => item.run_reports === 1 || item.run_reports === true)) {
            setRunReports(true);
        } else {
            setRunReports(false);
        }
    }, [groupPermissionsData]);

    const handleChangeGroupPermissions = (e, id) => {
        let tmp = {};
        groupPermissionsData.forEach((item) => {
            tmp[item.id] = item;
        });
        tmp[id] = { ...tmp[id], id, [e.target.name]: e.target.checked };
        setGroupPermissionsData(Object.values(tmp));
    };

    const handleChangeColumnGroupPermissions = (e) => {
        const tmp = groupPermissionsData;
        if (e.target.name === 'editDevices') {
            setEditDevices(e.target.checked);
            tmp.forEach((item) => (item.edit_device = e.target.checked));
        } else if (e.target.name === 'editPolicies') {
            setEditPolicies(e.target.checked);
            tmp.forEach((item) => (item.edit_policy = e.target.checked));
        } else if (e.target.name === 'editRates') {
            setEditRates(e.target.checked);
            tmp.forEach((item) => (item.edit_energy = e.target.checked));
        } else if (e.target.name === 'viewDevices') {
            setViewDevices(e.target.checked);
            tmp.forEach((item) => (item.view_devices = e.target.checked));
        } else if (e.target.name === 'wakeDevices') {
            setWakeDevices(e.target.checked);
            tmp.forEach((item) => (item.wake_devices = e.target.checked));
        } else {
            setRunReports(e.target.checked);
            tmp.forEach((item) => (item.run_reports = e.target.checked));
        }
        setGroupPermissionsData(tmp);
    };

    const handleSave = () => {
        onSave(groupPermissionsData);
        onClose();
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Edit Group Permissions</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Table sx={{ minWidth: 700 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ color: 'black', fontWeight: 'bold', padding: '5px' }}>Group Name</TableCell>
                            <TableCell sx={{ textAlign: 'center', padding: '5px' }}>
                                <Checkbox name="editDevices" checked={editDevices} onChange={handleChangeColumnGroupPermissions} />
                                <Typography sx={{ color: 'black', fontWeight: 'bold' }}>Edit Devices</Typography>
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center', padding: '5px' }}>
                                <Checkbox name="editPolicies" checked={editPolicies} onChange={handleChangeColumnGroupPermissions} />
                                <Typography sx={{ color: 'black', fontWeight: 'bold' }}>Edit Policies</Typography>
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center', padding: '5px' }}>
                                <Checkbox name="editRates" checked={editRates} onChange={handleChangeColumnGroupPermissions} />
                                <Typography sx={{ color: 'black', fontWeight: 'bold' }}>Edit Rates</Typography>
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center', padding: '5px' }}>
                                <Checkbox name="viewDevices" checked={viewDevices} onChange={handleChangeColumnGroupPermissions} />
                                <Typography sx={{ color: 'black', fontWeight: 'bold' }}>View Devices</Typography>
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center', padding: '5px' }}>
                                <Checkbox name="wakeDevices" checked={wakeDevices} onChange={handleChangeColumnGroupPermissions} />
                                <Typography sx={{ color: 'black', fontWeight: 'bold' }}>Wake Devices</Typography>
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center', padding: '5px' }}>
                                <Checkbox name="runReports" checked={runReports} onChange={handleChangeColumnGroupPermissions} />
                                <Typography sx={{ color: 'black', fontWeight: 'bold' }}>Run Reports</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {groupPermissionsData
                            .sort((a, b) => a.order - b.order)
                            .map((groupData, key) => (
                                <TableRow key={key}>
                                    <TableCell sx={{ padding: 0, paddingLeft: `${(groupData.depth - 1) * 24 + 10}px` }}>
                                        {groupData.name}
                                    </TableCell>
                                    <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                        <Checkbox
                                            name="edit_device"
                                            checked={groupData.edit_device}
                                            onChange={(e) => handleChangeGroupPermissions(e, groupData.id)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                        <Checkbox
                                            name="edit_policy"
                                            checked={groupData.edit_policy}
                                            onChange={(e) => handleChangeGroupPermissions(e, groupData.id)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                        <Checkbox
                                            name="edit_energy"
                                            checked={groupData.edit_energy}
                                            onChange={(e) => handleChangeGroupPermissions(e, groupData.id)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                        <Checkbox
                                            name="view_devices"
                                            checked={groupData.view_devices}
                                            onChange={(e) => handleChangeGroupPermissions(e, groupData.id)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                        <Checkbox
                                            name="wake_devices"
                                            checked={groupData.wake_devices}
                                            onChange={(e) => handleChangeGroupPermissions(e, groupData.id)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ padding: 0, textAlign: 'center' }}>
                                        <Checkbox
                                            name="run_reports"
                                            checked={groupData.run_reports}
                                            onChange={(e) => handleChangeGroupPermissions(e, groupData.id)}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

EditGroupPermissionDialog.propTypes = {
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    data: PropTypes.array
};

export default EditGroupPermissionDialog;
